import { render, staticRenderFns } from "./exitButton.vue?vue&type=template&id=779cf039&"
import script from "./exitButton.vue?vue&type=script&lang=js&"
export * from "./exitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports